/* NoveaHome — clone v2 · interactions */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var fmt = (window.NV && NV.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    var thousands = comma.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousands)
              .replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };

  /* ---------------- Mobile nav ---------------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-nv-menu-open]');
    var c = e.target.closest('[data-nv-menu-close]');
    var m = $('#nv-mnav'); if (!m) return;
    if (o) { e.preventDefault(); m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (c) { e.preventDefault(); m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  });
  // close dropdown on outside click
  document.addEventListener('click', function (e) {
    $$('details.nv-drop[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------------- Cart drawer ---------------- */
  var Cart = {
    el: function () { return $('#nv-cd'); },
    open: function () { var d = this.el(); if (!d) { location.href = '/cart'; return; } this.render(); d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; },
    close: function () { var d = this.el(); if (d) d.classList.remove('is-open'); document.documentElement.style.overflow = ''; },
    count: function (n) { $$('[data-nv-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-count', n); }); },
    render: function () {
      var self = this, d = this.el(); if (!d) return;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        self.count(cart.item_count);
        var box = $('[data-nv-items]', d), ft = $('[data-nv-ft]', d);
        if (!cart.items.length) {
          box.innerHTML = '<div class="nv-cd__empty"><p>' + esc(d.dataset.empty) + '</p><a class="nv-btn" href="/collections/all">' + esc(d.dataset.shop) + '</a></div>';
          ft.hidden = true; return;
        }
        ft.hidden = false;
        box.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="nv-ci__v">' + esc(it.variant_title) + '</div>' : '';
          return '<div class="nv-ci" data-line="' + (i + 1) + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div></div>') +
            '<div><a class="nv-ci__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
            '<div class="nv-ci__q"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
            '<div><button type="button" class="nv-ci__rm" data-q="0">' + esc(d.dataset.remove) + '</button></div></div>' +
            '<div class="nv-ci__p">' + money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<br><s style="color:#7b7b7b;font-weight:500">' + money(it.original_line_price) + '</s>' : '') + '</div></div>';
        }).join('');
        $('[data-nv-sub]', d).textContent = money(cart.total_price);
      });
    },
    change: function (line, q) {
      var self = this;
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
        .then(function () { return self.render(); });
    },
    add: function (fd) {
      var self = this;
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { self.open(); });
    }
  };
  window.NVCart = Cart;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nv-cart-open]')) { e.preventDefault(); Cart.open(); }
    if (e.target.closest('[data-nv-cart-close]')) { e.preventDefault(); Cart.close(); }
    var q = e.target.closest('.nv-ci [data-q]');
    if (q) { var line = +q.closest('.nv-ci').dataset.line; Cart.change(line, Math.max(0, +q.dataset.q)); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { Cart.close(); var m = $('#nv-mnav'); if (m) m.classList.remove('is-open'); } });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form.nv-form'); if (!f) return;
    e.preventDefault();
    var btns = $$('.nv-atc[form="' + f.id + '"], .nv-atc', f.ownerDocument).filter(function (b) { return b.form === f; });
    btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    Cart.add(new FormData(f)).catch(function (err) {
      alertBox(f, (err && (err.description || err.message)) || 'Erreur, veuillez réessayer.');
    }).then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); syncAvail(); });
  });
  function alertBox(f, msg) {
    var n = f.querySelector('[data-nv-err]'); if (!n) return;
    n.textContent = msg; n.hidden = false; setTimeout(function () { n.hidden = true; }, 5000);
  }

  /* ---------------- Tabs (bestsellers) ---------------- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-nv-tab]'); if (!p) return;
    var root = p.closest('[data-nv-tabs]');
    $$('[data-nv-tab]', root).forEach(function (x) { x.classList.toggle('is-on', x === p); x.setAttribute('aria-selected', x === p); });
    $$('.nv-tab', root).forEach(function (t) { t.hidden = t.dataset.panel !== p.dataset.nvTab; });
  });

  /* ---------------- Rails (arrows + progress) ---------------- */
  function initRail(root) {
    var rail = $('.nv-rail', root); if (!rail) return;
    $$('[data-nv-prev],[data-nv-next]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.hasAttribute('data-nv-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    var bar = $('.nv-prog__bar i', root);
    if (bar) {
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var w = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        bar.style.width = Math.min(100, w * 100) + '%';
        bar.style.left = max > 0 ? (rail.scrollLeft / max) * (100 - w * 100) + '%' : '0';
      };
      rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    }
  }

  /* ---------------- UGC videos ---------------- */
  function initUgc(root) {
    var vids = $$('.nv-vid', root);
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        var v = $('video', en.target); if (!v) return;
        if (en.isIntersecting && root.dataset.autoplay === 'true') { v.play().then(function () { en.target.classList.add('is-playing'); }).catch(function () {}); }
        else if (!en.isIntersecting) { v.pause(); en.target.classList.remove('is-playing'); }
      });
    }, { threshold: 0.6 }) : null;
    vids.forEach(function (card) {
      var v = $('video', card); if (!v) return;
      if (io) io.observe(card);
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var snd = e.target.closest('.nv-vid__snd');
        if (snd) { v.muted = !v.muted; card.classList.toggle('is-unmuted', !v.muted); snd.innerHTML = v.muted ? ICON_MUTED : ICON_SOUND; if (v.paused) v.play(); card.classList.add('is-playing'); return; }
        if (v.paused) { $$('video', root).forEach(function (o) { if (o !== v) o.pause(); }); v.play(); card.classList.add('is-playing'); }
        else { v.pause(); card.classList.remove('is-playing'); }
      });
    });
  }
  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m23 9-6 6M17 9l6 6"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';

  /* ---------------- Product: gallery / variants / qty / sticky ---------------- */
  function initPdp(root) {
    var dataEl = $('script[data-nv-variants]', root); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = $('form.nv-form', root);
    var main = $$('.nv-gal__main img', root), thumbs = $$('.nv-thumb', root);
    var show = function (i) {
      if (!main.length) return;
      i = (i + main.length) % main.length;
      main.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      root.dataset.idx = i;
    };
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    show(+(root.dataset.start || 0) < main.length ? +(root.dataset.start || 0) : 0);
    var pv = $('.nv-gal__nav--p', root), nx = $('.nv-gal__nav--n', root);
    if (pv) pv.addEventListener('click', function () { show(+(root.dataset.idx || 0) - 1); });
    if (nx) nx.addEventListener('click', function () { show(+(root.dataset.idx || 0) + 1); });
    // swipe
    var g = $('.nv-gal__main', root), sx = null;
    if (g) {
      g.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(+(root.dataset.idx || 0) + (dx < 0 ? 1 : -1)); sx = null; });
    }
    var zoom = $('.nv-gal__zoom', root);
    if (zoom) zoom.addEventListener('click', function () { var on = $('.nv-gal__main img.is-on', root); if (on) window.open(on.dataset.full || on.src, '_blank'); });

    // qty
    $$('.nv-qty', root).forEach(function (q) {
      var inp = $('input', q);
      $$('button', q).forEach(function (b) { b.addEventListener('click', function () { inp.value = Math.max(1, (+inp.value || 1) + (+b.dataset.step)); }); });
    });

    // variants
    var opts = $$('.nv-opt', root);
    var pick = function () {
      var sel = opts.map(function (o) { var c = $('input:checked', o); return c ? c.value : null; });
      var v = variants.find(function (vv) { return vv.options.every(function (ov, i) { return ov === sel[i]; }); });
      opts.forEach(function (o, i) { var c = $('input:checked', o), s = $('legend span', o); if (s && c) s.textContent = c.value; });
      if (!v) { setBtn(false, root.dataset.unavailable); return; }
      $('input[name="id"]', form).value = v.id;
      setPrice(v);
      setBtn(v.available, v.available ? root.dataset.atc : root.dataset.soldout);
      if (v.media_index != null) show(v.media_index);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      // mark unavailable combos for last option
      opts.forEach(function (o, oi) {
        $$('input', o).forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var m = variants.find(function (vv) { return vv.options.every(function (ov, i) { return ov === test[i]; }); });
          inp.nextElementSibling.classList.toggle('is-na', !m || !m.available);
        });
      });
    };
    var setBtn = function (ok, label) {
      $$('.nv-atc', root.ownerDocument).filter(function (b) { return b.form === form; }).forEach(function (b) { b.disabled = !ok; b.textContent = label; });
    };
    var setPrice = function (v) {
      $$('[data-nv-price]').forEach(function (p) { p.textContent = money(v.price); });
      var on = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-nv-was]').forEach(function (p) { p.textContent = on ? money(v.compare_at_price) : ''; p.hidden = !on; });
      $$('[data-nv-save]').forEach(function (p) { p.hidden = !on; var t = $('b', p); if (t) t.textContent = on ? money(v.compare_at_price - v.price) : ''; });
      $$('[data-nv-sale]').forEach(function (p) { p.hidden = !on; });
      $$('[data-nv-off]').forEach(function (p) { p.hidden = !on; p.textContent = on ? '-' + money(v.compare_at_price - v.price) : ''; });
      $$('[data-nv-split]').forEach(function (p) { p.textContent = money(Math.ceil(v.price / 3)); });
    };
    opts.forEach(function (o) { o.addEventListener('change', pick); });

    // sticky
    var sticky = $('.nv-sticky');
    var anchor = $('.nv-buy', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(anchor);
    }
  }
  function syncAvail() {}

  /* ---------------- LED preview ---------------- */
  var TEMPS = {
    warm:    { tint: 'radial-gradient(circle at 50% 45%, rgba(255,170,70,.95), rgba(255,140,40,.55) 60%, rgba(255,120,30,.35))', glow: 'radial-gradient(circle at 50% 45%, rgba(255,190,110,.55), rgba(255,160,70,0) 65%)', filter: 'sepia(.22) saturate(1.15) hue-rotate(-6deg)', dot: '#FFB46B' },
    neutral: { tint: 'radial-gradient(circle at 50% 45%, rgba(255,240,215,.7), rgba(255,235,205,.35) 60%, rgba(255,235,205,.15))', glow: 'radial-gradient(circle at 50% 45%, rgba(255,246,228,.5), rgba(255,246,228,0) 65%)', filter: 'saturate(1)', dot: '#FFEFD6' },
    cool:    { tint: 'radial-gradient(circle at 50% 45%, rgba(150,195,255,.95), rgba(120,170,255,.55) 60%, rgba(110,160,255,.35))', glow: 'radial-gradient(circle at 50% 45%, rgba(200,225,255,.55), rgba(180,210,255,0) 65%)', filter: 'saturate(.9) hue-rotate(8deg)', dot: '#CFE3FF' }
  };
  var LEVELS = { 1: { b: .62, t: .55, g: .15 }, 2: { b: .92, t: .8, g: .45 }, 3: { b: 1.12, t: 1, g: .85 } };
  function initLed(root) {
    var st = { temp: root.dataset.temp || 'warm', level: +(root.dataset.level || 2) };
    var imgs = $$('.nv-led__img', root), tint = $('.nv-led__tint', root), glow = $('.nv-led__glow', root), tag = $('.nv-led__tag', root);
    var apply = function () {
      var T = TEMPS[st.temp], L = LEVELS[st.level];
      // dedicated photo for this temperature?
      var dedicated = imgs.filter(function (i) { return i.dataset.temp === st.temp; })[0];
      var base = imgs.filter(function (i) { return i.dataset.temp === 'base'; })[0];
      var active = dedicated || base;
      imgs.forEach(function (i) { i.hidden = i !== active; });
      var useTint = !dedicated;
      active.style.filter = (useTint ? T.filter + ' ' : '') + 'brightness(' + L.b + ') contrast(' + (st.level === 3 ? 1.04 : 1) + ')';
      tint.style.background = T.tint; tint.style.opacity = useTint ? L.t : 0;
      glow.style.background = T.glow; glow.style.opacity = L.g;
      $$('[data-temp-btn]', root).forEach(function (b) { b.classList.toggle('is-on', b.dataset.tempBtn === st.temp); b.setAttribute('aria-pressed', b.dataset.tempBtn === st.temp); });
      $$('[data-level-btn]', root).forEach(function (b) { b.classList.toggle('is-on', +b.dataset.levelBtn === st.level); b.setAttribute('aria-pressed', +b.dataset.levelBtn === st.level); });
      var tb = $('[data-temp-btn="' + st.temp + '"]', root), lb = $('[data-level-btn="' + st.level + '"]', root);
      if (tag) { tag.style.setProperty('--dot', T.dot); $('span', tag).textContent = (tb ? tb.dataset.label : '') + ' · ' + (lb ? lb.dataset.label : ''); }
      $$('[data-nv-led-cur-temp]', root).forEach(function (n) { n.textContent = tb ? tb.dataset.label : ''; });
      $$('[data-nv-led-cur-level]', root).forEach(function (n) { n.textContent = lb ? lb.dataset.label : ''; });
    };
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-temp-btn]'), l = e.target.closest('[data-level-btn]');
      if (t) { st.temp = t.dataset.tempBtn; apply(); }
      if (l) { st.level = +l.dataset.levelBtn; apply(); }
    });
    apply();
  }

  function boot() {
    $$('[data-nv-rail]').forEach(initRail);
    $$('[data-nv-ugc]').forEach(initUgc);
    $$('[data-nv-pdp]').forEach(initPdp);
    $$('[data-nv-led]').forEach(initLed);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { Cart.count(c.item_count); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
